module.exports = __webpack_public_path__ + "static/img/M6.8b51f5c3.png";